export default __webpack_public_path__ + "static/media/19.3e58002d.gif";